import { Notification } from 'element-ui'

function createProxy(service) {
  const $service = {}
  Object.keys(service).forEach((key) => {
    if (typeof service[key] === 'function') {
      $service[key] = async (args, message) => {
        return service[key](args)
          .then((result) => {
            if (message) {
              Notification({
                title: '操作成功',
                type: 'success',
                message
              })
            }
            return result
          })
          .catch((error) => {
            if ((error.request && error.request.status === 401) || error.code === 10001) {
              location.reload()
            } else {
              if (key === 'uploadMinIcon' || key === 'uploadGuideIcon') {
                return Promise.reject(error)
              }
              Notification({
                customClass: 'notification-wrapper',
                title: '操作失败',
                type: 'error',
                message: error.message
              })
              return Promise.reject(error)
            }
          })
      }
    } else {
      $service[key] = service[key]
    }
  })
  return $service
}

function install(Vue) {
  Vue.mixin({
    beforeCreate() {
      const service = this.$options.service
      const $parent = this.$parent
      if (service) {
        this.$service = createProxy(service)
      } else if ($parent && $parent.$service) {
        this.$service = this.$parent.$service
      }
    }
  })
}

const servicePlugin = { install }

export { servicePlugin as default }
